import type { ToastVariant } from '../../components/ui/Toast/ToastProvider';

type Notify = (message: string, variant?: ToastVariant) => void;

let notifyImpl: Notify = (message) => {
  console.warn('[notifications] тост ещё не подключён:', message);
};

export const registerNotifier = (impl: Notify): void => {
  notifyImpl = impl;
};

export const notifyError = (message: string): void => notifyImpl(message, 'error');
export const notifySuccess = (message: string): void => notifyImpl(message, 'success');
export const notifyInfo = (message: string): void => notifyImpl(message, 'info');
export const notifyWarning = (message: string): void => notifyImpl(message, 'warning');